import { render, staticRenderFns } from "./hour.vue?vue&type=template&id=20523496&scoped=true&"
import script from "./hour.vue?vue&type=script&lang=js&"
export * from "./hour.vue?vue&type=script&lang=js&"
import style0 from "./hour.vue?vue&type=style&index=0&id=20523496&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20523496",
  null
  
)

export default component.exports